export default __webpack_public_path__ + "static/media/Avatar1.cbe35f72.webp";